/**
 * Auth convenience hook: store selectors plus logout (revoke + cache clear).
 */

import { useAuthStore } from '@/stores/authStore';
import { auth } from '@/config/firebase';
import { signOut } from 'firebase/auth';
import { useQueryClient } from '@tanstack/react-query';
import { logoutFromBackend } from '@/services/auth.service';

/** Auth store plus logout (`POST /auth/logout`, Firebase sign-out, query cache). */
export const useAuth = () => {
  const { user, isAuthenticated, logout: logoutStore } = useAuthStore();
  const queryClient = useQueryClient();

  const logout = async () => {
    try {
      localStorage.setItem('intentional_logout', 'true');
      // Revoke the Firebase refresh token server-side. Local logout still runs
      // if the backend is down or the token is already expired.
      try {
        await logoutFromBackend();
      } catch {
        // Keep going — do not block local logout.
      }
      await signOut(auth);
    } catch (error) {
      console.error('Firebase signOut error:', error);
    } finally {
      queryClient.clear();
      logoutStore();
    }
  };

  return {
    user,
    isAuthenticated,
    logout,
  };
};
